// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vlH4","delete":"styles_delete__1ApiC","update":"styles_update__SxUlq","add":"styles_add__2JkbU"};